import React from 'react';
import { Badge } from '../../../components/ui/Badge';
import type { Task } from '../../../core/models/Task';

/**
 * What the client has said about a task from ChatGPT: where they would rank
 * it, and whether they accepted finished work. Their rank is a suggestion and
 * is shown separately from our own priority.
 */
export const TaskClientBadges: React.FC<{
  task: Pick<Task, 'status' | 'clientPriority' | 'clientAcceptance'>;
}> = ({ task }) => {
  const rank = task.clientPriority?.rank;
  // An old verdict stops applying once the task is reopened.
  const acceptance = task.status === 'done' ? task.clientAcceptance : null;
  if (rank == null && !acceptance && task.status !== 'done') return null;
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      {rank != null && (
        <Badge variant="outline" title={task.clientPriority?.note || undefined}>
          Client rank #{rank}
        </Badge>
      )}
      {acceptance?.status === 'accepted' && (
        <Badge variant="success">Accepted by client</Badge>
      )}
      {acceptance?.status === 'changes_requested' && (
        <Badge variant="error" title={acceptance.note || undefined}>
          Sent back by client
        </Badge>
      )}
      {task.status === 'done' && !acceptance && (
        <Badge variant="warning">Awaiting client acceptance</Badge>
      )}
    </span>
  );
};
